export default {
  "boardOperations": "Operaciones del tablero",
  "manageDailyAssignmentsWorkflowAndCompletionStatus": "Gestiona las asignaciones diarias, el flujo de trabajo y el estado de finalización.",
  "generateBoard": "Generar tablero",
  "newTask": "Nueva tarea",
  "myTasks": "Mis tareas",
  "staffProfileUnavailable": "(perfil de personal no disponible)",
  "boardNotGeneratedYet": "El tablero aún no se ha generado",
  "loading": "Cargando…",
  "noWorkOrders": "No hay órdenes de trabajo.",
  "staffWorkload": "Carga de trabajo del personal",
  "noStaffAssignmentsYet": "Aún no hay asignaciones de personal.",
  "selectedRoute": "Ruta seleccionada",
  "selectAStaffMemberToReorderTheirRoute": "Selecciona a una persona para reordenar su ruta.",
  "roomStatus": "Estado de habitaciones",
  "allOccupancy": "Toda la ocupación",
  "vacant": "Vacante",
  "occupied": "Ocupada",
  "reserved": "Reservada",
  "outOfOrder": "Fuera de servicio por avería",
  "outOfService": "Fuera de servicio",
  "housekeeping": "Limpieza",
  "allHousekeeping": "Todos los estados de limpieza",
  "ready": "Lista",
  "needsCleaning": "Necesita limpieza",
  "inProgress": "En curso",
  "inspectionPending": "Inspección pendiente",
  "blocked": "Bloqueada",
  "allRoomsCurrentlyReady": "Todas las habitaciones están listas.",
  "housekeepingStaff": "Personal de limpieza",
  "manageTheStaffRosterAvailableForHousekeepingTaskAssignment": "Gestiona el personal disponible para asignar tareas de limpieza.",
  "searchHousekeepingStaff": "Buscar personal de limpieza",
  "addStaff": "Añadir personal",
  "staff": "Personal",
  "active": "Activo",
  "inactive": "Inactivo",
  "edit": "Editar",
  "deactivate": "Desactivar",
  "reactivate": "Reactivar",
  "noHousekeepingStaffRosterEntriesYet": "Aún no hay personal en el equipo de limpieza.",
  "addHousekeepingStaff": "Añadir personal de limpieza",
  "selectFromClubStaffAndAddToTheHousekeepingRoster": "Selecciona personal del club para añadirlo al equipo de limpieza.",
  "searchStaff": "Buscar personal",
  "noMatchingStaff": "No se ha encontrado personal.",
  "shiftPreference": "Turno preferido",
  "any": "Cualquiera",
  "am": "Mañana",
  "pm": "Tarde",
  "notes": "Notas",
  "cancel": "Cancelar",
  "editHousekeepingStaff": "Editar personal de limpieza",
  "updateHousekeepingSpecificRosterSettings": "Actualiza la configuración del equipo de limpieza.",
  "displayOrder": "Orden de visualización",
  "save": "Guardar",
  "newWorkOrder": "Nueva orden de trabajo",
  "createAnAdHocOrPublicAreaTaskForTheBoard": "Crea una tarea puntual o de zona común para el tablero.",
  "selectType": "Seleccionar tipo",
  "roomCode": "Código de habitación",
  "eG1204": "p. ej., 1204",
  "selectPriority": "Seleccionar prioridad",
  "high": "Alta",
  "medium": "Media",
  "low": "Baja",
  "estimatedMinutes": "Duración estimada en minutos",
  "dueAt": "Fecha límite",
  "createTask": "Crear tarea",
  "assignStaff": "Asignar personal",
  "start": "Iniciar",
  "block": "Bloquear",
  "complete": "Completar",
  "inspect": "Inspeccionar",
  "clear": "Borrar",
  "up": "Subir",
  "down": "Bajar",
  "unassigned": "Sin asignar",
  "assigned": "Asignada",
  "needsInspection": "Necesita inspección",
  "done": "Finalizada",
  "closed": "Cerrada",
  "adHoc": "Puntual",
  "publicArea": "Zona común",
  "deepClean": "Limpieza a fondo",
  "maintenance": "Mantenimiento",
  "inspection": "Inspección",
  "checkout": "Limpieza de salida",
  "stayover": "Limpieza durante la estancia",
  "room": "Habitación",
  "nA": "No disponible",
  "invalid": "No válido",
  "addABlockingNoteOptional": "Añade una nota sobre el bloqueo (opcional):",
  "didTheRoomPassInspection": "¿La habitación ha superado la inspección?",
  "inspectionNotesOptional": "Notas de inspección (opcional):",
  "editTask": "Editar tarea",
  "newHousekeepingTask": "Nueva tarea de limpieza",
  "roomNumber": "Habitación {number}",
  "assignedStaff": "Personal asignado",
  "scheduledTime": "Hora programada",
  "serviceType": "Tipo de servicio",
  "dailyCleaning": "Limpieza diaria",
  "checkoutCleaning": "Limpieza de salida",
  "deepCleaning": "Limpieza a fondo",
  "pending": "Pendiente",
  "completed": "Completada",
  "onHold": "En espera",
  "urgent": "Urgente",
  "updateTask": "Actualizar tarea",
  "housekeepingBoard": "Tablero de limpieza",
  "visualBoardOfRoomStatusesAndCleaningTasks": "Tablero visual del estado de habitaciones y las tareas de limpieza.",
  "noHousekeepingTasksFound": "No hay tareas de limpieza.",
  "createFirstTask": "Crear primera tarea",
  "searchingStaff": "Buscando personal…",
  "typeAtLeast2CharactersToSearch": "Escribe al menos 2 caracteres para buscar.",
  "noResultsFound": "No se han encontrado resultados.",
  "boardName": "Tablero: {name}",
  "dueDate": "Fecha límite: {date}",
  "assignedName": "Asignado: {name}",
  "shiftShiftOrderOrder": "Turno: {shift} • Orden: {order}",
  "countMinutesMin": "{count} • {minutes} min",
  "unableToCompleteThisHousekeepingRequestPleaseTryAgain": "No se ha podido completar esta solicitud de limpieza. Inténtalo de nuevo.",
  "staffSearchIsUnavailablePleaseTryAgain": "La búsqueda de personal no está disponible. Inténtalo de nuevo.",
  "errors": {
    "invalid_request": "La solicitud de limpieza no es válida.",
    "room_not_found": "No se ha encontrado la habitación.",
    "not_found": "No se ha encontrado el registro de limpieza.",
    "invalid_status": "El estado no es válido.",
    "invalid_status_transition": "Este cambio de estado no está permitido.",
    "staff_not_found": "No se ha encontrado a la persona.",
    "board_required": "Genera un tablero antes de asignar tareas.",
    "invalid_shift_preference": "El turno preferido no es válido.",
    "invalid_display_order": "Introduce un orden de visualización válido.",
    "no_updates": "No hay cambios que guardar."
  },
  "enums": {
    "status": {
      "queued": "Sin asignar",
      "assigned": "Asignada",
      "in_progress": "En curso",
      "blocked": "Bloqueada",
      "needs_inspection": "Necesita inspección",
      "done": "Finalizada",
      "closed": "Cerrada",
      "pending": "Pendiente",
      "completed": "Completada",
      "on_hold": "En espera",
      "ready": "Lista",
      "needs_cleaning": "Necesita limpieza",
      "inspected": "Inspección pendiente",
      "cancelled": "Cancelada"
    },
    "type": {
      "ad_hoc": "Puntual",
      "public_area": "Zona común",
      "deep_clean": "Limpieza a fondo",
      "maintenance": "Mantenimiento",
      "inspection": "Inspección",
      "checkout": "Limpieza de salida",
      "stayover": "Limpieza durante la estancia",
      "daily_cleaning": "Limpieza diaria",
      "checkout_cleaning": "Limpieza de salida",
      "deep_cleaning": "Limpieza a fondo",
      "checkout_clean": "Limpieza de salida",
      "stayover_clean": "Limpieza durante la estancia",
      "arrival_refresh": "Preparación para la llegada"
    },
    "priority": {
      "high": "Alta",
      "medium": "Media",
      "low": "Baja",
      "urgent": "Urgente"
    },
    "occupancy": {
      "vacant": "Vacante",
      "occupied": "Ocupada",
      "reserved": "Reservada",
      "out_of_order": "Fuera de servicio por avería",
      "out_of_service": "Fuera de servicio"
    },
    "shift": {
      "ANY": "Cualquiera",
      "AM": "Mañana",
      "PM": "Tarde"
    }
  },
  "status": "Estado",
  "type": "Tipo",
  "priority": "Prioridad",
  "occupancy": "Ocupación",
  "shift": "Turno",
  "boardDate": "Fecha del tablero",
  "requiredField": "Completa este campo obligatorio.",
  "generatedBoardName": "Tablero de limpieza {date} {shift}"
};
